import FeatureGates from '@atlaskit/feature-gate-js-client';

export type ChatRefreshV2Config = {
	isMinimodalHeightAnimationEnabled: boolean;
	isThinkDeeperEnabled: boolean;
	isDeepResearchEnabled: boolean;
	isNewMessagesEnabled: boolean;
	isNewMessagesActionsEnabled: boolean;
	isNewAllConversationScreenEnabled: boolean;
	isNewInputPromptTypeaheadEnabled: boolean;
	isDynamicStartersAPIEnabled: boolean;
	isReasoningOptionsV2Enabled: boolean;
	isReasoningStickyOptionEnabled: boolean;
	isPromptLibraryEnabled: boolean;
	isChromeExtensionLinkEnabled?: boolean;
	isNewLoadingStateEnabled: boolean;
	isSpinnerOverlayConversationIconEnabled: boolean;
};

export const initialState: ChatRefreshV2Config = {
	isMinimodalHeightAnimationEnabled: false,
	isThinkDeeperEnabled: false,
	isDeepResearchEnabled: false,
	isNewMessagesEnabled: false,
	isNewMessagesActionsEnabled: false,
	isNewAllConversationScreenEnabled: false,
	isNewInputPromptTypeaheadEnabled: false,
	isDynamicStartersAPIEnabled: false,
	isReasoningOptionsV2Enabled: false,
	isReasoningStickyOptionEnabled: false,
	isPromptLibraryEnabled: false,
	isNewLoadingStateEnabled: false,
	isSpinnerOverlayConversationIconEnabled: false,
};

const rovoChatRefreshV2ConfigDefaultValues = JSON.stringify(initialState);

export const getChatRefreshV2DynamicConfig = ({
	isRolloutInJiraEnabled,
}: {
	isRolloutInJiraEnabled: boolean;
}) => {
	const rovoChatRefreshV2ConfigResponse =
		isRolloutInJiraEnabled ||
		FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v1_experiment',
			'isRenderRefreshEnabled',
			false,
		)
			? FeatureGates.getExperimentValue(
					'rovo_chat_refresh_v2_config',
					'value',
					rovoChatRefreshV2ConfigDefaultValues,
				)
			: rovoChatRefreshV2ConfigDefaultValues;

	let rovoChatRefreshV2Config = initialState;

	try {
		rovoChatRefreshV2Config = JSON.parse(rovoChatRefreshV2ConfigResponse) as ChatRefreshV2Config;
	} catch (error) {
		// fail silently
	}

	return rovoChatRefreshV2Config;
};
